module.exports = __webpack_public_path__ + "media/images/items/thumbnail-6-9650bc3ee681d9c2f494aede94a448d1.jpg";